import * as Sentry from "@sentry/remix";
import { useLocation, useMatches } from "@remix-run/react";
import { useEffect } from "react";
import { registerSessionReplayRecorder } from "./sessionReplayRecorder";
import { telemetryConfiguration } from "./telemetryConfiguration";
import type { TelemetryOptions } from "./TelemetryOptions";

export function initializeTelemetry({
  enabled,
  environment,
}: TelemetryOptions) {
  const sessionReplayRecorder = Sentry.replayIntegration();

  Sentry.init({
    ...telemetryConfiguration,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    enabled,
    environment,
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      sessionReplayRecorder,
    ],
  });

  registerSessionReplayRecorder(sessionReplayRecorder);
}
